(function(){
  'use strict';
  if (window.__seamindGridInit) return;
  window.__seamindGridInit = true;

  // OPTIMIZACIÓN: una sola llamada HTTP combina "agregar al carrito" + "obtener sección
  // re-renderizada del drawer". Antes hacíamos 3 llamadas (add + cart + sections).
  async function addToCartWithSections(variantId, qty){
    const res = await fetch('/cart/add.js?sections=cart-drawer', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
    });
    if (!res.ok) {
      let msg = 'No se pudo agregar el producto.';
      try { const j = await res.json(); msg = j.description || j.message || msg; } catch(_) {}
      throw new Error(msg);
    }
    return res.json();
  }

  function openCartDrawer(addResult){
    // 1) SeaMind cart drawer (preferido) — pasa sections via event para que NO refetchee
    const smDrawer = document.querySelector('seamind-cart-drawer');
    if (smDrawer && typeof smDrawer.open === 'function') {
      document.dispatchEvent(new CustomEvent('seamind:cart:updated', {
        detail: { sections: addResult && addResult.sections ? addResult.sections : null }
      }));
      return;
    }

    // 2) Dawn cart drawer (fallback)
    const dawnDrawer = document.querySelector('cart-drawer');
    if (dawnDrawer && typeof dawnDrawer.open === 'function') { dawnDrawer.open(); return; }

    // 3) Último recurso: click sobre el ícono
    const cartIcon = document.querySelector('[data-cart-drawer-toggle], .header__icon--cart');
    if (cartIcon) { cartIcon.click(); return; }
  }

  document.addEventListener('click', async function(e){
    const btn = e.target.closest('[data-seamind-add]');
    if (!btn) return;
    e.preventDefault();

    const variantId = btn.dataset.variantId;
    const qty = parseInt(btn.dataset.qty || '1', 10);
    if (!variantId) { console.warn('SeaMind: missing data-variant-id'); return; }

    const original = btn.innerHTML;
    btn.classList.add('is-loading');
    btn.disabled = true;

    try {
      const result = await addToCartWithSections(variantId, qty);

      btn.classList.remove('is-loading');
      btn.classList.add('is-success');
      btn.innerHTML = 'Caja agregada ✓';

      setTimeout(function(){
        btn.classList.remove('is-success');
        btn.innerHTML = original;
        btn.disabled = false;
      }, 1400);

      openCartDrawer(result);
    } catch(err){
      btn.classList.remove('is-loading');
      btn.disabled = false;
      btn.innerHTML = original;
      console.error('SeaMind cart error:', err);
      alert(err.message || 'No se pudo agregar la caja al carrito.');
    }
  });
})();
